<template>
  <Input
    :id
    v-model="displayValue"
    :label
    :error
    :placeholder
    :maxLength
    :formatter="formatInput"
    :name
    inputmode="numeric"
    autocomplete="cc-exp"
    @keydown.delete.stop="onDelete"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { VueEvent } from '@cvo/ui/types/vue-common';
import Input from '../../atoms/Input/Input.vue';
import { MONTH_YEAR_CONFIG, type MonthYearInputProps } from './MonthYearInput.model';
import { formatInput } from './monthYearValue';

const props = withDefaults(defineProps<MonthYearInputProps>(), {
  yearFormat: 'YYYY',
  error: undefined,
});

const { monthLength, separator } = MONTH_YEAR_CONFIG;
const maxLength = computed(() => monthLength + separator.length + props.yearFormat.length);

const displayValue = defineModel<string>({ default: '' });

/**
 * Detects deletion or backspace
 */
function onDelete(event: VueEvent<KeyboardEvent, HTMLInputElement>) {
  const cursorPos = event.target.selectionStart ?? 0;
  const startYearPos = monthLength + separator.length;

  if (cursorPos <= startYearPos) {
    const endSlice = cursorPos === startYearPos ? monthLength : cursorPos;
    event.target.value = event.target.value.slice(0, endSlice);
  }
}
</script>
